import { ApiError } from '~/api/types'
import { classifyError } from './classifyError'
import { useToast } from './useToast'
import { useDevLog } from './useDevLog'

export function handleApiError(error: unknown): void {
  if (!(error instanceof ApiError)) {
    useDevLog.getState().push({ kind: 'error', message: 'Non-API error', detail: error })
    throw error
  }
  const cls = classifyError(error.envelope)
  useDevLog.getState().push({
    kind: cls.tier === 'inline' ? 'warn' : 'error',
    message: `[${error.envelope.code}] ${error.envelope.message}`,
    detail: { url: error.url, status: error.status, hint: error.envelope.hint },
  })
  switch (cls.tier) {
    case 'toast':
      useToast.getState().push({ message: cls.userMessage, level: 'error' })
      break
    case 'boundary':
      throw error
    case 'inline':
      break
    case 'dev-only':
      break
  }
}

export function getInlineMessage(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null
  const cls = classifyError(error.envelope)
  return cls.tier === 'inline' ? cls.userMessage : null
}

export function errorString(err: unknown): string | null {
  if (err == null) return null
  const inline = getInlineMessage(err)
  if (inline) return inline
  if (err instanceof Error) return err.message
  return null
}
